import { useNavigate } from 'react-router-dom'

function PaymentErrorPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h1 className="text-3xl font-bold text-[#001F3F] mb-3">Paiement échoué</h1>
        <p className="text-gray-600 mb-2">Le paiement n'a pas pu être complété.</p>
        <p className="text-gray-500 text-sm mb-8">
          Votre publication n'a pas été activée. Vous pouvez réessayer depuis votre tableau de bord.
        </p>
        <div className="space-y-3">
          <button
            onClick={() => navigate(-1)}
            className="w-full py-3 bg-gradient-to-r from-[#D4AF37] to-[#C49B2E] text-white font-bold rounded-xl hover:shadow-lg transition-all"
          >
            Réessayer le paiement
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full py-3 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition-all"
          >
            Tableau de bord
          </button>
        </div>
      </div>
    </div>
  )
}

export default PaymentErrorPage
